import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import CouponServices from '../../services/CouponServices';
import InventoryServices from '../../services/InventoryServices';
import UserServices from '../../services/UserServices';

function UpdateInvestor({ user, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        name: "",
        email: "",
        mobileNo: null, // Initialize as null instead of an empty string
        dateofbirth: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
        accountHolderName: "",
        accountNo: "",
        bankName: "",
        ifscCode: "",
    });
    const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return ''; // Return an empty string for invalid dates
        }
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    useEffect(() => {
        if (user) {
            setFormValues({
                name: user?.name || '',
                email: user?.email || '',
                mobileNo: user?.mobileNo || '',
                dateofbirth: user?.dateofbirth ? formatDate(user?.dateofbirth) : '',
                address: user?.address || '',
                state: user?.state || '',
                city: user?.city || '',
                pincode: user?.pincode || '',
                accountHolderName: user?.accountHolderName || '',
                accountNo: user?.accountNo || '',
                bankName: user?.bankName || '',
                ifscCode: user?.ifscCode || '',
            });

        }
    }, [user]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    // const handleFileChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setPreviewImage(reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //         setFormValues({
    //             ...formValues,
    //             image: file,
    //         });
    //     }
    // };

    const handleSubmit = async (event) => {
        event.preventDefault();


        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }

            await UserServices.updateInvestor(user.id, formData);
            alert('Investor updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.error('Failed to update Investor', error);
            alert(error.response.data.message || 'Failed to update Investor');
        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Edit Investor</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Name*</label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        className="form-control"
                                                        value={formValues.name}
                                                        onChange={handleInputChange}
                                                        placeholder="Investor's full name"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Email*</label>
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        className="form-control"
                                                        value={formValues.email}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter email address"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Phone Number*</label>
                                                    <input
                                                        type="text"
                                                        name="mobileNo"
                                                        className="form-control"
                                                        maxLength={10}
                                                        minLength={10}
                                                        value={formValues.mobileNo}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Phone Number"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Date of Birth (Optional)</label>
                                                    <input
                                                        type="date"
                                                        name="dateOfBirth"
                                                        className="form-control"
                                                        value={formValues.dateOfBirth}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Phone Number"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Address*</label>
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        className="form-control"
                                                        value={formValues.address}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Address"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>City*</label>
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        className="form-control"
                                                        value={formValues.city}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter City"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>State*</label>
                                                    <input
                                                        type="text"
                                                        name="state"
                                                        className="form-control"
                                                        value={formValues.state}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter State"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Pincode*</label>
                                                    <input
                                                        type="text"
                                                        name="pincode"
                                                        className="form-control"
                                                        value={formValues.pincode}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Pincode"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Account Holder Name*</label>
                                                    <input
                                                        type="text"

                                                        name="accountHolderName"
                                                        className="form-control"
                                                        value={formValues.accountHolderName}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Account Holder Name"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Bank Account Number*</label>
                                                    <input
                                                        type="text"
                                                        maxLength={12}
                                                        name="accountNo"
                                                        className="form-control"
                                                        value={formValues.accountNo}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Bank Account Number"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Bank Name*</label>
                                                    <input
                                                        type="text"
                                                        name="bankName"
                                                        className="form-control"
                                                        value={formValues.bankName}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Bank Name"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>IFSC Code*</label>
                                                    <input
                                                        type="text"
                                                        name="ifscCode"
                                                        className="form-control"
                                                        value={formValues.ifscCode}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter IFSC Code"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button className="site-btn-green">Save</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateInvestor;
